"use client";

import { useEffect, useRef } from "react";
import type { Locale } from "@/lib/i18n";

const API_BASE = (process.env.NEXT_PUBLIC_API_URL || "http://localhost:4000").replace(
  /\/$/,
  ""
);

/** Tekil görüntülemede sayacı artırır (detay sayfasında bir kez). */
export function BlogViewTracker({ slug, locale }: { slug: string; locale: Locale }) {
  const sent = useRef(false);

  useEffect(() => {
    if (sent.current) return;
    sent.current = true;
    void fetch(
      `${API_BASE}/api/blogs/slug/${encodeURIComponent(slug)}/view?locale=${locale}`,
      { method: "POST" }
    );
  }, [slug, locale]);

  return null;
}
